import type { Stripe } from '@stripe/stripe-js'
import { updateStripeOffSessionCardByRegionAndPurposeId } from 'api/payment'
import config from 'constants/config'

interface UpdateLuxPlusPrimaryCardInput {
  confirmWithSetup?: boolean
  currencyCode: string
  paymentMethodId: string
  purposeId: string
  regionCode: string
  /** Remove the member's invalid backup cards once the new primary is saved. Only the LP+ invalid card modal sets this. */
  removeInvalidCards?: boolean
  stripe: Stripe
}

async function updateLuxPlusPrimaryCard(input: UpdateLuxPlusPrimaryCardInput): Promise<void> {
  const {
    confirmWithSetup,
    currencyCode,
    paymentMethodId,
    purposeId,
    regionCode,
    removeInvalidCards,
    stripe,
  } = input

  const { clientSecret } = await updateStripeOffSessionCardByRegionAndPurposeId(regionCode, purposeId, {
    currency: currencyCode,
    brand: config.BRAND,
    paymentMethodType: 'card',
    metadata: {
      paymentMethodId,
      purpose: 'lux_plus',
      ...(removeInvalidCards && { removeInvalidCards: true }),
    },
  })

  const setupResult = confirmWithSetup ? await stripe.confirmSetup({
    clientSecret,
    redirect: 'if_required',
  }) : await stripe.confirmCardSetup(clientSecret)

  if (setupResult.error) {
    throw new Error(setupResult.error.message)
  }
}

export default updateLuxPlusPrimaryCard
